/*************************************************/
/* ACCORDION-IMAGES                              */
/*************************************************/
import customEventsNames from '../customEventsNames';
export function accordionImages() {
    const accordionImagesContainerSelector = ".accordion-images__images-container";
    const accordionImageSelector = ".accordion-images__image";
    const accordionImageActiveClass = "accordion-images__image--active";
    const accordionImageFallbackClass = "accordion-images__image--fallback";
    const defaultItemIndex = 1; // The index of the default item

    const init = () => {
        const imageContainers = document.querySelectorAll(accordionImagesContainerSelector);
        if (imageContainers) {
            imageContainers.forEach(container => {


                // Select both the default and fallback images
                const images = container.querySelectorAll(accordionImageSelector);

                if (images.length > defaultItemIndex) {
                    // Hide the fallback image by removing the active class
                    images[0].classList.remove(accordionImageActiveClass);

                    // Add the active class to the default image
                    images[defaultItemIndex].classList.add(accordionImageActiveClass);
                }

                container.addEventListener(customEventsNames.accordionActivateItemEventName, e => {
                    let i = 0;
                    container.querySelectorAll(accordionImageSelector).forEach(image => {
                        image.classList.remove(accordionImageActiveClass);
                        if (image.classList.contains(accordionImageFallbackClass)) return;
                        if (i == e.detail.accordionItemIndex) {
                            image.classList.add(accordionImageActiveClass);
                        }
                        i++;
                    });
                });
            });
        }
    };

    init();
}